<dx-popup
  id="declinaison-produit-dialog-edit"
  [visible]="displayDialog()"
  (visibleChange)="displayDialog.set($event)"
  [height]="'auto'"
  [width]="'auto'"
  [maxWidth]="'95vw'"
  [maxHeight]="'95vh'"
  [showCloseButton]="false">

  <div *dxTemplate="let _ of 'title'" class="declinaison-header">
    <div class="declinaison-header-title" [innerHTML]="domSanitizer.bypassSecurityTrustHtml(getTitle(produitDeclinaison()))"></div>

    <div class="declinaison-header-actions">
      <yo-declinaison-help></yo-declinaison-help>
      @if (multiSites() && denree()) {
        <yo-button iconClass="fas fa-cubes" [theme]="ButtonThemeEnum.DEFAULT"
                   (onClick)="openGestionStockMini()" tooltip="Gestion du stock minimum"></yo-button>
      }
      @if (produitDeclinaison()?.id !== 0) {
        <yo-button iconClass="fas fa-random" [theme]="ButtonThemeEnum.DEFAULT"
                   (onClick)="openDialogChangeUniteTechnique()" tooltip="Changer l'unité technique"></yo-button>
      }
      <yo-button iconClass="fas fa-save" [theme]="ButtonThemeEnum.SAVE" (onClick)="save()"
                 [disabled]="!gds.canModify(produitDeclinaison())" tooltip="Enregistrer"></yo-button>
      @if (produitDeclinaison()?.id !== 0) {
        <yo-button iconClass="fas fa-trash" [theme]="ButtonThemeEnum.DELETE"
                   (onClick)="openDeleteDialog(produitDeclinaison())" [disabled]="!canDelete()"
                   tooltip="Supprimer"></yo-button>
      }
      <yo-button iconClass="fas fa-times" [theme]="ButtonThemeEnum.CANCEL" tooltip="Fermer"
                 (onClick)="closeDialog()"></yo-button>
    </div>
  </div>

  @if (formData() && produitDeclinaison()) {
    <section class="declinaison-content">

      <!-- INFORMATIONS : commun à denrée et plat -->
      <ng-template #informationsFieldsTpl>
        <div class="declinaison-panel">
          <span class="declinaison-panel-title"><strong>INFORMATIONS</strong></span>
          <div class="declinaison-panel-body">
            <div class="declinaison-row">
              <span>Site</span>
              <yo-site [siteId]="produitDeclinaison()?.site?.id" [siteLibelle]="produitDeclinaison()?.site?.libelle"></yo-site>
            </div>
            <div class="declinaison-row">
              <span>Libellé <span class="danger-color">*</span></span>
              <yo-text-box [value]="formData().libelle" [disabled]="isReadonly()" [readonly]="isReadonly()"
                           (onValueChanged)="onChangeLibelle($event)"></yo-text-box>
            </div>

            @if (produitDeclinaison().fabrique) {
              <div class="declinaison-row">
                <span>Déclinaison <span class="danger-color">*</span></span>
                <yo-lookup [data]="declinaisonList()" [selectedItem]="formData().declinaison?.id"
                           [disabled]="isReadonly() || declinaisonLocked()"
                           (onValueChange)="onChangeDeclinaison($event)"></yo-lookup>
              </div>
              <div class="declinaison-row">
                <span>Libellé complet <span class="danger-color">*</span></span>
                <yo-text-box [value]="formData().libellelong" [disabled]="isReadonly()" [readonly]="isReadonly()"
                             (onValueChanged)="onChangeLibelleLong($event)"></yo-text-box>
              </div>
            } @else {
              <div class="declinaison-row">
                <span>Libellé complet <span class="danger-color">*</span></span>
                <yo-text-box [value]="formData().libellelong" [disabled]="isReadonly()" [readonly]="isReadonly()"
                             (onValueChanged)="onChangeLibelleLong($event)"></yo-text-box>
              </div>
              <div class="declinaison-row">
                <span>Déclinaison <span class="danger-color">*</span></span>
                <yo-lookup [data]="declinaisonList()" [selectedItem]="formData().declinaison?.id"
                           [disabled]="isReadonly() || declinaisonLocked()"
                           (onValueChange)="onChangeDeclinaison($event)"></yo-lookup>
              </div>
            }

            <div class="declinaison-row">
              <span>Code</span>
              <yo-text-box [value]="formData().code"
                           (onValueChanged)="onChangeCode($event)"></yo-text-box>
            </div>
            <div class="declinaison-row">
              <span>Reference</span>
              <yo-text-box [value]="formData().reference"
                           (onValueChanged)="onChangeReference($event)"></yo-text-box>
            </div>
            <div class="declinaison-row">
              <span>Code ciqual</span>
              <yo-number-box [value]="formData().codealim" [disabled]="isReadonly() || isLockedAfterCreation()"
                             [readonly]="isReadonly() || isLockedAfterCreation()"
                             (onValueChanged)="onChangeCodeAlim($event)"></yo-number-box>
            </div>
            <div class="declinaison-row">
              <span>Active</span>
              <dx-check-box [value]="formData().actif" [disabled]="isReadonly()"
                            (onValueChanged)="onChangeActif($event.value)"></dx-check-box>
            </div>
            <div class="declinaison-row">
              <span>Complémentaire</span>
              <dx-check-box [value]="formData().complementaire" [disabled]="isReadonly()"
                            (onValueChanged)="onChangeComplementaire($event.value)"></dx-check-box>
            </div>
          </div>
        </div>
      </ng-template>

      @if (!produitDeclinaison().fabrique) {
        <yo-declinaison-denree
          [data]="denreeData()"
          (changeCompteComptable)="onChangeCompteComptable($event)"
          (changeTaxe)="onChangeTaxe($event)"
          (changeUniteDeMesure)="onChangeUniteDeMesure($event)"
          (changeRatioUniteTechnique)="onChangeRatioUniteTechnique($event)"
          (changeInverseRatioUniteTechnique)="onChangeInverseRatioUniteTechnique($event)"
          (changeZoneDeStockage)="onChangeZoneDeStockage($event)"
          (changeTacheApprovisionnement)="onChangeTacheApprovisionnement($event)"
          (changeTacheSortie)="onChangeTacheSortie($event)"
          (changeFamilleEgalim)="onChangeFamilleEgalim($event)"
          (changeDlc)="onChangeDlc($event)"
          (changeStockMinimum)="onChangeStockMinimum($event)"
          (changeRatioVolume)="onChangeRatioVolume($event)"
          (changePrixDeVente)="onChangePrixDeVente($event)">
          <ng-container ngProjectAs="[informationsFields]" *ngTemplateOutlet="informationsFieldsTpl"></ng-container>
        </yo-declinaison-denree>
      }

      @if (produitDeclinaison().fabrique) {
        <yo-declinaison-plat
          [data]="platData()"
          (changeCompteComptable)="onChangeCompteComptable($event)"
          (changeTaxe)="onChangeTaxe($event)"
          (changeFamilleFacturation)="onChangeFamilleFacturation($event)"
          (changeUniteDeMesure)="onChangeUniteDeMesure($event)"
          (changeRatioUniteTechnique)="onChangeRatioUniteTechnique($event)"
          (changeInverseRatioUniteTechnique)="onChangeInverseRatioUniteTechnique($event)"
          (changeTacheFabrication)="onChangeTacheFabrication($event)"
          (changeRegimes)="onChangeRegimes($event)"
          (changeDlc)="onChangeDlc($event)"
          (changeRatioVolume)="onChangeRatioVolume($event)"
          (changePrixDeVente)="onChangePrixDeVente($event)">
          <ng-container ngProjectAs="[informationsFields]" *ngTemplateOutlet="informationsFieldsTpl"></ng-container>
        </yo-declinaison-plat>
      }

    </section>
  }
</dx-popup>

<yo-dialog-change-unite-technique
  [denree]="produitDeclinaison()"
  [(displayDialog)]="showChangeUniteTechnique"
  (saved)="onNewUniteTechnique($event)">
</yo-dialog-change-unite-technique>

@if (gds.canModify(produitDeclinaison())) {
  <yo-gestion-stock-minimum-dialog [produitDeclinaison]="produitDeclinaison()"></yo-gestion-stock-minimum-dialog>
}
